import type { Components, Theme } from '@mui/material';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: { palette, typography } }) => ({
      ...typography['natter-text-sm'],
      color: palette.grey[400],

      '&.MuiInputLabel-shrink': {
        color: palette.grey[600],

        '&.Mui-focused:not(.Mui-error)': {
          color: palette.primary.main,
        },

        '&.Mui-error': {
          color: palette.error.main,
        },
      },

      '&.Mui-disabled': {
        color: palette.grey[300],
      },
    }),
    outlined: {
      transform: 'translate(16px, 14px) scale(1)',
      '&.MuiInputLabel-sizeSmall': {
        transform: 'translate(16px, 6px) scale(1)',
      },

      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -7px) scale(0.857)',
      },
    },
    asterisk: ({ theme: { palette } }) => ({
      color: palette.error.main,
    }),
  },
};
